// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
    /* max-height: calc(100vh - 365px); */
    overflow: auto;
}

table {
    overflow: auto;
    border-collapse: collapse;
    width: 100%;
}

.table-spec {
    width: 100%;
    max-width: 100%;
    empty-cells: show;
    border: 0;
}

td, th {
    border: 1px solid #dddddd;
    text-align: left;
    font-weight: normal;
}

td {
    padding: 6px 10px;
}

th {
    border-top: none;
    position: sticky;
    top: 0;
    padding: 10px;
    background: #212529;
    color: #ffffff;
    font-size: 14px;
    z-index: 1;
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

td .txtarea {
    width: 100% !important;
}

td textarea:hover {
    border: 1px solid gray !important;
}

.first td:nth-child(1) {
    color: teal;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImdyaWQuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLHFDQUFxQztJQUNyQyxjQUFjO0FBQ2xCOztBQUVBO0lBQ0ksY0FBYztJQUNkLHlCQUF5QjtJQUN6QixXQUFXO0FBQ2Y7O0FBRUE7SUFDSSxXQUFXO0lBQ1gsZUFBZTtJQUNmLGlCQUFpQjtJQUNqQixTQUFTO0FBQ2I7O0FBRUE7SUFDSSx5QkFBeUI7SUFDekIsZ0JBQWdCO0lBQ2hCLG1CQUFtQjtBQUN2Qjs7QUFFQTtJQUNJLGlCQUFpQjtBQUNyQjs7QUFFQTtJQUNJLGdCQUFnQjtJQUNoQixnQkFBZ0I7SUFDaEIsTUFBTTtJQUNOLGFBQWE7SUFDYixtQkFBbUI7SUFDbkIsY0FBYztJQUNkLGVBQWU7SUFDZixVQUFVO0FBQ2Q7O0FBRUE7SUFDSSx5QkFBeUI7QUFDN0I7O0FBRUE7SUFDSSxzQkFBc0I7QUFDMUI7O0FBRUE7SUFDSSxpQ0FBaUM7QUFDckM7O0FBRUE7SUFDSSxXQUFXO0FBQ2YiLCJmaWxlIjoiZ3JpZC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnRhYmxlLWNvbnRhaW5lciB7XHJcbiAgICAvKiBtYXgtaGVpZ2h0OiBjYWxjKDEwMHZoIC0gMzY1cHgpOyAqL1xyXG4gICAgb3ZlcmZsb3c6IGF1dG87XHJcbn1cclxuXHJcbnRhYmxlIHtcclxuICAgIG92ZXJmbG93OiBhdXRvO1xyXG4gICAgYm9yZGVyLWNvbGxhcHNlOiBjb2xsYXBzZTtcclxuICAgIHdpZHRoOiAxMDAlO1xyXG59XHJcblxyXG4udGFibGUtc3BlYyB7XHJcbiAgICB3aWR0aDogMTAwJTtcclxuICAgIG1heC13aWR0aDogMTAwJTtcclxuICAgIGVtcHR5LWNlbGxzOiBzaG93O1xyXG4gICAgYm9yZGVyOiAwO1xyXG59XHJcblxyXG50ZCwgdGgge1xyXG4gICAgYm9yZGVyOiAxcHggc29saWQgI2RkZGRkZDtcclxuICAgIHRleHQtYWxpZ246IGxlZnQ7XHJcbiAgICBmb250LXdlaWdodDogbm9ybWFsO1xyXG59XHJcblxyXG50ZCB7XHJcbiAgICBwYWRkaW5nOiA2cHggMTBweDtcclxufVxyXG5cclxudGgge1xyXG4gICAgYm9yZGVyLXRvcDogbm9uZTtcclxuICAgIHBvc2l0aW9uOiBzdGlja3k7XHJcbiAgICB0b3A6IDA7XHJcbiAgICBwYWRkaW5nOiAxMHB4O1xyXG4gICAgYmFja2dyb3VuZDogIzIxMjUyOTtcclxuICAgIGNvbG9yOiAjZmZmZmZmO1xyXG4gICAgZm9udC1zaXplOiAxNHB4O1xyXG4gICAgei1pbmRleDogMTtcclxufVxyXG5cclxudGJvZHkgdHI6bnRoLWNoaWxkKGV2ZW4pIHtcclxuICAgIGJhY2tncm91bmQtY29sb3I6ICNmMmYyZjI7XHJcbn1cclxuXHJcbnRkIC50eHRhcmVhIHtcclxuICAgIHdpZHRoOiAxMDAlICFpbXBvcnRhbnQ7XHJcbn1cclxuXHJcbnRkIHRleHRhcmVhOmhvdmVyIHtcclxuICAgIGJvcmRlcjogMXB4IHNvbGlkIGdyYXkgIWltcG9ydGFudDtcclxufVxyXG5cclxuLmZpcnN0IHRkOm50aC1jaGlsZCgxKSB7XHJcbiAgICBjb2xvcjogdGVhbDtcclxufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/View/core/poc/grid/grid.component.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;AACA,46DAA46D","sourcesContent":[".table-container {\r\n    /* max-height: calc(100vh - 365px); */\r\n    overflow: auto;\r\n}\r\n\r\ntable {\r\n    overflow: auto;\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n}\r\n\r\n.table-spec {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    empty-cells: show;\r\n    border: 0;\r\n}\r\n\r\ntd, th {\r\n    border: 1px solid #dddddd;\r\n    text-align: left;\r\n    font-weight: normal;\r\n}\r\n\r\ntd {\r\n    padding: 6px 10px;\r\n}\r\n\r\nth {\r\n    border-top: none;\r\n    position: sticky;\r\n    top: 0;\r\n    padding: 10px;\r\n    background: #212529;\r\n    color: #ffffff;\r\n    font-size: 14px;\r\n    z-index: 1;\r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\ntd .txtarea {\r\n    width: 100% !important;\r\n}\r\n\r\ntd textarea:hover {\r\n    border: 1px solid gray !important;\r\n}\r\n\r\n.first td:nth-child(1) {\r\n    color: teal;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
